"use client";
'use strict';

var cookies = require('js-cookie');
var React = require('react');
var consts = require('@sravni/utils/lib/consts');
var theme = require('@sravni/utils/lib/theme');
var dom = require('../../utils/dom.js');
var consts$1 = require('./consts.js');
var Context = require('./Context.js');

function UncontrolledThemeProvider(props) {
    const { initialTheme, children } = props;
    const [currentTheme, setCurrentTheme] = React.useState(initialTheme);
    const setTheme = React.useCallback(
    // isTrusted - true if function called by user action
    (theme, isTrusted = true) => {
        if (isTrusted) {
            cookies.set(consts.COOKIES.USER_THEME, theme, {
                expires: new Date(new Date().getTime() + consts$1.COOKIE_MAX_AGE),
                sameSite: 'Lax',
                path: '/',
            });
        }
        setCurrentTheme(theme);
    }, [setCurrentTheme]);
    React.useEffect(() => {
        if (!dom.isBrowser) {
            return;
        }
        const node = document.documentElement;
        node?.setAttribute(theme.ATTR_NAME, currentTheme);
    }, [currentTheme]);
    const value = React.useMemo(() => ({ theme: currentTheme, setTheme }), [currentTheme, setTheme]);
    return React.createElement(Context.ThemeContext.Provider, { value: value }, children);
}

exports.UncontrolledThemeProvider = UncontrolledThemeProvider;
//# sourceMappingURL=Uncontrolled.js.map
